module.exports = "input {\n    text-transform: unset;\n}\n\ntextarea {\n    text-transform: unset;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/config/config.component.css
// module id = ./src/app/config/config.component.css
// module chunks = main